import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=6b6e06d4&scoped=true&"
import script from "./Load.vue?vue&type=script&lang=js&"
export * from "./Load.vue?vue&type=script&lang=js&"
import style0 from "./Load.vue?vue&type=style&index=0&id=6b6e06d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6e06d4",
  null
  
)

export default component.exports